import React, { useMemo, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import DtoEvent from '../../../../../events/dto/DtoEvent'
import { getYear } from '../../../../../utils/DateUtil'
import TechniqueEventCard from '../../../../../station/components/event/TechniqueEventCard'
import SmallEventCard from '../../../../../station/components/event/SmallEventCard'
import { EVENT_TYPES, EVENT_TYPES_CODES } from '../../../../../events/constants/EventsConstants'
import GlobalCardList from '../../../../../components/list/cardList/GlobalCardList'
import { groupBy, omit, orderBy } from 'lodash'
import { getEventColor } from '../../../../../utils/ColorUtil'
import Select from '../../../../../components/forms/Select'
import { getI18nTitleData, i18nize } from '../../../../../utils/StringUtil'
import { CardTitle } from '../../../../../components/card/NewCard'
import { Card, CardContent, Grid } from '@mui/material'
import Checkbox from '../../../../../components/forms/Checkbox'

const StationSuiviEventsTab = ({ id, displayEvents, changeParent, stationType }) => {
    const [eventType, setEventType] = useState('')

    const {
        stationEvents,
    } = useSelector(store => ({
        stationEvents: store.EventsReducer.stationEvents,
    }), shallowEqual)

    const getEventCard = event => {
        return event.eventType === EVENT_TYPES_CODES.TECHNIQUE ?
            <TechniqueEventCard
                event={event}
                shortDate
                link={`station/${stationType}/${id}/event/`}
            />
            : <SmallEventCard
                event={event}
                shortDate
                link={`station/${stationType}/${id}/event/`}
            />
    }

    const events = eventType ? stationEvents.filter(d => d.eventType === eventType) : stationEvents

    const data = useMemo(() => {
        const groupedEvents = groupBy(events, d => getYear(d.date))
        return Object.keys(groupedEvents).map(key => ({
            title: <div className='valign-wrapper no-margin no-padding'>
                {`${key} (${groupedEvents[key].length} ${getI18nTitleData(i18n.element, i18n.elements, groupedEvents[key])})`}
            </div>,
            cards: orderBy(groupedEvents[key], e => e.date || e.eventDate, 'desc').map(e => ({
                color: getEventColor(e.eventType),
                content: getEventCard(e),
            })),
        }))
    }, [events])

    return (
        <Card>
            <CardTitle title={events.length ? `${i18n.events} (${events.length} ${getI18nTitleData(i18n.element, i18n.elements, events)})` : i18n.noEvents} />
            <CardContent>
                <Grid container spacing={1} justifyContent='center' alignItems='center'>
                    <Grid size={6} className='padding-top-1'>
                        <Select
                            className='no-margin'
                            nullLabel='&nbsp;'
                            value={eventType}
                            options={i18nize(EVENT_TYPES).map(d => omit(d, 'icon'))}
                            label={i18n.eventTypes}
                            onChange={v => setEventType(v)}
                        />
                    </Grid>
                    <Grid size={6} className='padding-top-2'>
                        <Checkbox
                            checked={displayEvents}
                            label={i18n.displayEventsOnChart}
                            onChange={v => changeParent({ displayEvents: v })}
                        />
                    </Grid>
                    <Grid size={12}>
                        <GlobalCardList
                            smallTitle
                            data={data}
                            collapsible
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

StationSuiviEventsTab.propTypes = {
    id: PropTypes.number,
    stationEvents: PropTypes.arrayOf(DtoEvent),
    displayEvents: PropTypes.bool,
    changeParent: PropTypes.func,
    stationType: PropTypes.string,
}

export default StationSuiviEventsTab